export default {
    namespaced: true,
    state: {
        funeral_director: {},
        fd_logo: null,
    },
    actions: {
        set_funeral_director({ commit }, payload) {
            commit('set_funeral_director', payload)
        },
        set_fd_logo({ commit }, payload) {
            commit('set_fd_logo', payload)
        },
    },
    mutations: {
        set_funeral_director(state, payload) {
            state.funeral_director = payload
        },
        set_fd_logo(state, payload) {
            state.fd_logo = payload
        },
    },
    getters: {
        get_funeral_director: state => state.funeral_director,
        get_fd_logo: state => state.fd_logo,
    }
}